import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
const NoPostYet = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "50px",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderRadius: "10px",
      }}
    >
      <h2 style={{ fontSize: "24px", color: "#333" }}>
        🧐 Oups, aucun contenu pour l'instant !
      </h2>
      <p style={{ fontSize: "16px", color: "#555" }}>
        Cette personne n'a encore rien publié. Revenez plus tard ! 🌟
      </p>
      <div style={{ fontSize: "40px", marginTop: "20px" }}>
        🤔 🤷‍♂️ 🚀
      </div>
    </div>
  );
};

export default NoPostYet;
export {NoPostYet}